<!-- Editor de ecrã inteiro. Só existe no DOM enquanto está aberto: o
     componente vive no `body` e um painel `fixed` escondido só por CSS
     bloqueava o ecrã. Sem clique no fundo para fechar, para não perder um
     recorte a meio; Esc fecha. -->
<div class="crop-panel" *ngIf="isOpen" tabindex="-1" role="dialog" aria-labelledby="cropPanelTitle">
    <header class="crop-header">
        <div class="crop-header-title">
            <i class="ri-crop-2-line"></i>
            <div>
                <h5 id="cropPanelTitle" class="mb-0">{{ 't-crop-image' | translate }}</h5>
                <small class="text-truncate d-block" *ngIf="imgData?.name || imgData?.fileName">{{ imgData?.name || imgData?.fileName }}</small>
            </div>
        </div>
        <div class="crop-header-actions">
            <button type="button" class="btn btn-ghost-light btn-sm" (click)="resetCrop()"
                [disabled]="isLoadImg || !image" *ngIf="!isLegacy">
                <i class="ri-arrow-go-back-line align-bottom me-1"></i>{{ 't-crop-reset' | translate }}
            </button>
            <button type="button" class="btn btn-light btn-sm" (click)="close()">{{ 't-cancel' | translate }}</button>
            <button type="button" class="btn btn-primary btn-sm" (click)="saveImage()" [disabled]="isLoadImg || !image">
                <i class="ri-check-line align-bottom me-1"></i>{{ 't-btn-save' | translate }}
            </button>
            <button type="button" class="btn-close btn-close-white ms-2" [attr.aria-label]="'t-close' | translate" (click)="close()"></button>
        </div>
    </header>

    <div class="crop-stage" (wheel)="onMouseWheel($event)">
        <image-cropper [imageFile]="image" [maintainAspectRatio]="!isFit" [aspectRatio]="publishedAspect"
            format="jpeg" [autoCrop]="false" [cropper]="cropper" [transform]="transform"
            [canvasRotation]="canvasRotation" [resizeToWidth]="1000" [imageQuality]="92" [onlyScaleDown]="true" [roundCropper]="false"
            backgroundColor="#1c1f26" (imageLoaded)="onImageLoaded($event)" (cropperReady)="onCropperReady($event)"
            (loadImageFailed)="onLoadImageFailed()" (mouseup)="onCropperChange()" (touchend)="onCropperChange()"
            (keyup)="onCropperChange()">
        </image-cropper>

        <!-- Ferramentas sobre a imagem: rotação e zoom. -->
        <div class="crop-tools">
            <button type="button" class="crop-tool" (click)="rotateLeft()" [disabled]="isLoadImg || !image"
                [ngbTooltip]="'t-crop-rotate-left' | translate" container="body">
                <i class="ri-anticlockwise-line"></i>
            </button>
            <button type="button" class="crop-tool" (click)="rotateRight()" [disabled]="isLoadImg || !image"
                [ngbTooltip]="'t-crop-rotate-right' | translate" container="body">
                <i class="ri-clockwise-line"></i>
            </button>
            <span class="crop-tools-sep"></span>
            <button type="button" class="crop-tool" (click)="zoomOut()" [disabled]="isLoadImg || !image || !canZoomOut"
                [ngbTooltip]="'t-crop-zoom-out' | translate" container="body">
                <i class="ri-zoom-out-line"></i>
            </button>
            <span class="crop-zoom-value">{{ (scale * 100) | number: '1.0-0' }}%</span>
            <button type="button" class="crop-tool" (click)="zoomIn()" [disabled]="isLoadImg || !image || !canZoomIn"
                [ngbTooltip]="(!canZoomIn && image ? 't-crop-zoom-limit' : 't-crop-zoom-in') | translate" container="body">
                <i class="ri-zoom-in-line"></i>
            </button>
        </div>

        <!-- O resultado tal como vai ser publicado (sempre 16:9). -->
        <div class="crop-preview" *ngIf="cropImgPreview" [class.expanded]="previewExpanded"
            (click)="previewExpanded = !previewExpanded" tabindex="0" role="button">
            <span class="crop-preview-label">{{ 't-crop-preview' | translate }} · 16:9</span>
            <img [src]="cropImgPreview" alt="">
        </div>

        <div class="crop-loader" *ngIf="isLoadImg">
            <div class="spinner-border text-light" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>

    <footer class="crop-footer">
        <div class="alert alert-warning py-2 mb-2 fs-12" role="alert" *ngIf="isLegacy">
            <i class="ri-information-line align-middle me-1"></i>{{ 't-crop-legacy-limited' | translate }}
        </div>

        <div class="crop-modes" role="radiogroup" *ngIf="!isLegacy">
            <button type="button" class="crop-mode" [class.active]="mode === 'crop'" role="radio"
                [attr.aria-checked]="mode === 'crop'" (click)="setMode('crop')" [disabled]="isLoadImg || !image">
                <span class="crop-mode-thumb crop-mode-thumb-crop"><span></span></span>
                <span class="crop-mode-text">
                    <strong>{{ 't-crop-mode-cover' | translate }}</strong>
                    <small>{{ (isAlready169 ? 't-crop-mode-cover-hint-169' : 't-crop-mode-cover-hint') | translate: { loss: cropLossPercent } }}</small>
                </span>
            </button>
            <button type="button" class="crop-mode" [class.active]="mode === 'blur'" role="radio"
                [attr.aria-checked]="mode === 'blur'" (click)="setMode('blur')" [disabled]="isLoadImg || !image">
                <span class="crop-mode-thumb crop-mode-thumb-blur"><span></span></span>
                <span class="crop-mode-text">
                    <strong>{{ 't-crop-mode-fit' | translate }}</strong>
                    <small>{{ 't-crop-mode-fit-hint' | translate }}</small>
                </span>
            </button>
            <button type="button" class="crop-mode" [class.active]="mode === 'white'" role="radio"
                [attr.aria-checked]="mode === 'white'" (click)="setMode('white')" [disabled]="isLoadImg || !image">
                <span class="crop-mode-thumb crop-mode-thumb-white"><span></span></span>
                <span class="crop-mode-text">
                    <strong>{{ 't-crop-mode-white' | translate }}</strong>
                    <small>{{ 't-crop-mode-white-hint' | translate }}</small>
                </span>
            </button>
        </div>
    </footer>
</div>
